var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTree1Dark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100.3 159.11",
    style: {
      enableBackground: "new 0 0 100.3 159.11"
    },
    xmlSpace: "preserve",
    overflow: "visible",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.td10{fill:#D4D3D7;}\n\t.td11{fill:#6C401D;}\n\t.td12{fill:#945225;}\n\t.td13{fill:#0B8545;}\n\t.td14{fill:#0C6A37;}\n\t.st0{transform-origin: 50% 50%;  transform-box: fill-box;}\n\t.st1{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st2{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st3{transform-origin: 50% 100%; transform-box: fill-box;}\n\t.st4{transform-origin: 50% 100%; transform-box: fill-box;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0 td10",
    cx: 49.77,
    cy: 153.46,
    rx: 31.4,
    ry: 5.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1 td11",
    points: "54.92,95.59 45.5,95.59 41.5,154.2 58.92,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2 td12",
    points: "50.21,154.2 58.92,154.2 54.92,95.59 50.21,95.59  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 td11",
    d: "M73.34,92.87c0,0-11.58,13.54-21.14,17.23v-3.84c8.04-3.55,18.68-13.03,18.68-13.03L73.34,92.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3 td13",
    d: "M90.09,48.45c0.02-0.47,0.04-0.95,0.04-1.43c0-10.15-5.21-19.12-13.22-24.65c0.06-0.66,0.09-1.33,0.09-1.99 C77.35,7.03,60.59,0,50.21,0S22.37,6.54,22.42,20.38c0,0.67,0.03,1.33,0.09,1.99C14.51,27.9,9.29,36.88,9.29,47.02 c0,0.48,0.01,0.96,0.04,1.43C1.18,52.03,0,58.26,0,66.57c0,17.52,23.01,29.84,50.21,29.84s50.09-12.32,50.09-29.87 C100.3,58.23,99.24,52.31,90.09,48.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4 td14",
    d: "M50.21,82.91c-18.7,0-36.29-4.19-49.51-11.13c4.16,14.16,23.88,24.63,49.51,24.63S95.46,85.9,99.6,71.78 C86.38,78.72,68.91,82.91,50.21,82.91z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTree1Dark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tree1_dark.eced6b972b103e067e73f83ff072f2dc.svg";